// docs: https://white-light.feishu.cn/wiki/MsVuwxnvYi0z6KkbJRKcjaZAnhc?fromScene=spaceOverview

import { defineApi } from '@/utils/fetch';

import type {
    ICancelSubscriptionRequest,
    IGetAddedListRequest,
    IGetAddedListResponseData,
    IGetUsedListRequest,
    IGetUsedListResponseData,
    IUserInfoResponseData,
} from './typings';

export const TradeApi = {
    getAsset: defineApi<undefined, IUserInfoResponseData>({
        url: '/trade/query/v1/',
        method: 'GET',
    }),
    getAddedList: defineApi<IGetAddedListRequest, IGetAddedListResponseData>({
        url: '/trade/added_list/v1/',
        method: 'GET',
    }),
    getUsedList: defineApi<IGetUsedListRequest, IGetUsedListResponseData>({
        url: '/trade/used_list/v1/',
        method: 'GET',
    }),
    cancelSubscription: defineApi<ICancelSubscriptionRequest, undefined>({
        url: '/trade/cancel_subscription/v1/',
        method: 'POST',
    }),
};

export * from './typings';
